export default (state, payload) => {
  state.investors_filters.is_archived = payload;
};
